import { DataViewConfig, ExpandedViewConfig } from '@creditsights/styleguide-web';
import { InitialActionAllower, RouteToCallback } from '@creditsights/styleguide-web/components/DataView';
import { MY_CONTENT_ROUTES, ROUTES } from '../../../Base.constants';
import { CompaniesFormatter, DateRenderer, GhostLinkRenderer, TitleFormatter } from '../../../components/formatters';
import { ContentTypeRenderer } from '../../../components/formatters/ContentTypeRenderer';
import { ReadingListArticle } from '../../../models/ReadingListArticle';

export const sortArticles = (article1: ReadingListArticle, article2: ReadingListArticle): number => {
  const createdAt1 = article1.bookmarkedAt;
  const createdAt2 = article2.bookmarkedAt;
  return createdAt2.localeCompare(createdAt1);
};

export const getKey = (readingListArticle: ReadingListArticle): number => readingListArticle.articleId;

const expandedViewConfig = (
  getIdKey: () => string,
  shouldAllowInitialAction: InitialActionAllower,
  routeToCallback: RouteToCallback,
  savedDateClassName: string
): ExpandedViewConfig => ({
  title: {
    dataKey: 'title',
    dataRenderer: TitleFormatter,
    dataViewItemConfiguration: { getIdKey, shouldAllowInitialAction, routeToCallback },
  },
  subtitle: [
    {
      renderWithoutDataValue: true,
      dataRenderer: GhostLinkRenderer,
      dataViewItemConfiguration: { getIdKey, shouldAllowInitialAction, routeToCallback },
    },
    {
      dataKey: 'articleType',
      dataRenderer: ContentTypeRenderer,
      dataViewItemConfiguration: {
        getIdKey,
        shouldAllowInitialAction,
        routeToCallback,
      },
    },
    {
      dataKey: 'publishDate',
      dataRenderer: DateRenderer,
      dataViewItemConfiguration: {
        getIdKey,
        shouldAllowInitialAction,
        routeToCallback,
      },
    },
    {
      dataKey: 'companies',
      // TODO: Switch to TickersFormatter when Ticker data is fixed
      dataRenderer: CompaniesFormatter(),
      dataViewItemConfiguration: {
        stopMouseUpPropagation: true,
        getIdKey,
        shouldAllowInitialAction,
        routeToCallback,
      },
    },
    {
      dataKey: 'bookmarkedAt',
      dataRenderer: DateRenderer,
      dataViewItemConfiguration: {
        getIdKey,
        shouldAllowInitialAction,
        routeToCallback,
        className: savedDateClassName,
      },
      dataRendererProps: { label: 'Saved' },
    },
  ],
  contentIndent: true,
});

export const viewConfig = (savedDateClassName: string): DataViewConfig<ReadingListArticle> => {
  const shouldAllowInitialAction: InitialActionAllower = () => false;
  const routeToCallback: RouteToCallback = (articleId) =>
    `${ROUTES.myContent}/${MY_CONTENT_ROUTES.articles(articleId)}`;
  return {
    expandedViewConfig: expandedViewConfig(
      () => 'articleId',
      shouldAllowInitialAction,
      routeToCallback,
      savedDateClassName
    ),
    clickable: true,
  };
};
